import React, { useState } from 'react';
import branding from '../../branding.json';
import { LegalDocModal } from '../common/LegalDocModal';

export const Footer: React.FC = () => {
  const [legalModal, setLegalModal] = useState<'terms' | 'privacy' | null>(null);

  return (
    <>
      {legalModal && (
        <LegalDocModal docKey={legalModal} onClose={() => setLegalModal(null)} />
      )}
      <footer className="bg-gray-800 text-white p-4 mt-auto">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between text-sm">
          <p className="text-gray-400">
            {branding.copyright ||
              `\u00A9 ${new Date().getFullYear()} ${branding.appName}`}
          </p>
          <div className="flex space-x-4 mt-2 sm:mt-0">
            <button
              onClick={() => setLegalModal('terms')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Terms
            </button>
            <button
              onClick={() => setLegalModal('privacy')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Privacy
            </button>
            {branding.companyInfo?.email && (
              <a
                href={`mailto:${branding.companyInfo.email}`}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Contact
              </a>
            )}
          </div>
        </div>
      </footer>
    </>
  );
};
